<template>
  <div id="blog-area" class="container pb-70 mn-section">
    <div class="row">
      <div
        class="col-lg-6 offset-lg-3"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <h2 class="fs-52 mb-40 text-center">
          Update With Our Latest Blog & News
        </h2>
      </div>
    </div>
    <div class="row justify-content-center">
      <div
        class="col-xl-4 col-md-6"
        v-for="blog in blogs"
        :key="blog.id"
        data-aos="fade-up"
        data-aos-duration="1000"
        :data-aos-delay="blog.dataDelay"
      >
        <div class="home_three-blog-card mb-30">
          <div class="blog-img overflow-hidden">
            <img :src="blog.image" alt="Image" class="transition" />
          </div>
          <div class="blog-info">
            <h3 class="fs-26 lh-36">
              <router-link to="/blog-details-left-sidebar">
                {{ blog.title }}
              </router-link>
            </h3>
            <p>
              {{ blog.desc }}
            </p>
            <router-link to="/blog-details-left-sidebar" class="link style-one">
              Read More
              <img src="../../assets/img/icons/long-arrow.svg" alt="Image" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurLatestBlog",
  data() {
    return {
      blogs: [
        {
          id: 1,
          dataDelay: "200",
          image: require("../../assets/img/blog/blog-1.webp"),
          title: "Global Leaders Announce Climate Agreement To Curb",
          desc: "Discover how global couples are using technology to strengthen their relationships and stay connected.",
        },
        {
          id: 2,
          dataDelay: "300",
          image: require("../../assets/img/blog/blog-2.webp"),
          title: "Tech Giants Face Increased Scrutiny In ATC Investigations",
          desc: "Learn about the latest innovations in relationship technology and digital intimacy solutions.",
        },
        {
          id: 3,
          dataDelay: "400",
          image: require("../../assets/img/blog/blog-3.webp"),
          title: "SpaceX Launches Crewed Mission To Mars For Humanity",
          desc: "Explore how couples are pioneering new ways to share love and maintain connection across distances.",
        },
      ],
    };
  },
});
</script>

<style lang="scss" scoped>
.home_three-blog-card {
  margin-bottom: 30px;
  .blog-img {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    img {
      border-radius: 10px;
      transition: var(--transition);
    }
  }
  h3 {
    margin: 27px 0 10px;
  }
  p {
    margin-bottom: 25px;
  }
  &:hover {
    .blog-img {
      img {
        transform: scale(1.05);
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_three-blog-card {
    h3 {
      margin: 20px 0 10px;
    }
    p {
      margin-bottom: 17px;
    }
  }
}
</style>